// @flow
import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../../types';

const Filter = styled<any, Theme>('div')`
  margin: 0.5rem;
  background-color: ${props => props.theme.assortment.activeFilters.backgroundColor};
  color: ${props => props.theme.assortment.activeFilters.color};
  height: 2.5rem;
  padding-right: 1.5rem;
  display: flex;
  align-items: center;
  border-radius: 2px;
  font-size: 0.85rem;
  margin-top: 0;
  margin-left: 0;
`;

const Cross = styled<any, Theme>('i')`
  margin-left: 1rem;
  margin-right: 0.5rem;
  font-size: .6rem;
  cursor: pointer;
`;

type Props = {
  onDelete: Function,
  value: string,
  tabIndex: number,
};

export default ({ onDelete, value, tabIndex }: Props) => (
  <Filter>
    <a tabIndex={tabIndex} role="button" onClick={() => onDelete()}>
      <Cross className="icon-cross" />
    </a>
    {value}
  </Filter>
);
